import { useState } from "react";
import { FaCaretDown } from "react-icons/fa";
import { PiCaretDown } from "react-icons/pi";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

const SimpleDropdownInput = ({
  value,
  setValue,
  placeholder,
  options,
  renderValue,
  renderOption,
}) => {
  return (
    <UncontrolledDropdown>
      <DropdownToggle className="p-0 border-none bg-transparent full-width color-primary-black-2">
        <div
          style={{
            border: "1px solid rgb(164, 164, 164)",
            borderRadius: "0.5rem",
          }}
          className="px-3 py-3 d-flex align-items-center justify-content-between"
        >
          <p className="m-0">
            {value
              ? typeof value === "object" && renderValue
                ? renderValue(value)
                : typeof value === "object"
                ? value?.title ?? value?.name
                : value
              : placeholder}
          </p>
          <div>
            <PiCaretDown size={20} />
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu className="bg-transparent border-none outer-black-shadow p-0 full-width">
        <div className="full-width  bg-white ">
          {options?.map((item, key) => (
            <DropdownItem
              key={key}
              onClick={() => {
                if (setValue) setValue(item);
              }}
              style={{
                animation: `slide-from-above 0.2s linear`,
              }}
            >
              {typeof item === "object" && renderOption
                ? renderOption(item)
                : typeof item === "object"
                ? item?.title
                : item}
            </DropdownItem>
          ))}
        </div>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default SimpleDropdownInput;
